/* eslint-disable camelcase */
import Cookies from 'js-cookie'
import { appConfig, schemaMap } from './config'
import {
  CX_ARTICLE,
  CX_COMPONENT,
  CX_CONSENT,
  CX_ERROR,
  CX_NAVIGATION,
  CX_ORDER,
  CX_PAGE,
  CX_PLATFORM,
  // CX_PRODUCER,
  CX_USER
} from './mutations'

const cxOrderDefaults = {
  id: null, status: null, timestamp: null, total: null
}

const cx_article = {
  articleId: null,
  articleNameLocal: null,
  sectionId: null,
  sectionNameLocal: null
}

const cx_component = {
  id: null,
  name: '', // required
  position: null,
  type: null // required
}

const cx_error = {
  code: null,
  message: 'unknown' // required
}


export default {
  namespaced: true,
  state: {
    cx_article,
    cx_consent: {
      status: []
    },
    cx_component,
    cx_contactReason: {
      reasonLocal: null,
      subReasonLocal: null,
      reasonGlobal: null,
      subReasonGlobal: null
    },
    // "The value of the satisfaction score whether it is 'thumb up' = 1 / 'down' = 0 or 1-5 scale",
    cx_csat: {
      csatValue: null,
      csatMaxValue: null
    },
    cx_error,
    cx_feature: {
      name: 'helpCentre'
    },
    cx_navigation: {
      name: ''
    },
    cx_order: {
      ...cxOrderDefaults
    },
    cxPLatform: {
      language: '',
      country: '',
      version: ''
    },
    cx_producer: {
      team: appConfig.producer
    },
    cx_partner: {
      id: '', // required
      promoted: null,
      minimumOrderValue: null,
      status: null
    },
    cx_review: {
      qualityValue: '',
      deliveryValue: null,
      orderTimeArrivalValue: null
    },
    cx_user: {
      anonymousId: ''
    }
  },
  mutations: {
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {String} name event cx_navigation destination
     */
    [CX_NAVIGATION]: (state, name) => {
      state.cx_navigation.name = name
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Object} article null OR order Object as per API response
     */
    [CX_ARTICLE]: (state, article) => {
      state.cx_article = article
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Array} data ...
     */
    [CX_COMPONENT]: (state, data) => {
      state.cx_component = data
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Array} data ...
     */
    [CX_CONSENT]: (state, data) => {
      state.cx_consent.status = [...data]
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Array} data ...
     */
    [CX_ERROR]: (state, data) => {
      state.cx_error = data
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Object} data ...
     */
    [CX_PLATFORM]: (state, data) => {
      state.cxPLatform = { ...data }
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Object} data ...
     */
    [CX_PAGE]: (state, data) => {
      state.cx_page = data
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Object} data ...
     */
    [CX_USER]: (state, data) => {
      state.cx_user = data
    },
    /**
     * Mutate existing state
     * @param {Object} state
     * @param {Object} orderData null OR order Object as per API response
     */
    [CX_ORDER]: (state, order) => {
      state.cx_order = order
    }
  },
  actions: {
    /**
     * Set Analytics Global context values
     * @param {Object} context, getters from Vue store
     * @param {Object} routeName used to map to Navigation tracking
     */
    setGlobalContext({ commit, rootGetters /* , getters*/ } /* , route */) {
      const consentAcceptance = Cookies.get('je-cookieConsent')
      const consentType = Cookies.get('cookieConsent')
      const cookieConsent = [consentAcceptance, consentType]
      const locale = rootGetters.appLocale

      const platform = {
        language: locale,
        country: locale && locale.slice(-2).toLowerCase(),
        version: appConfig.packageVersion
      }
      const userCookieName = process.env.VUE_APP_JE_AUSER_COOKIE || 'je-auser'
      const anonymousId = Cookies.get(userCookieName) || ''

      // const anonymousId = getters.getUserId()
      // const anonymousId = rootGetters.user.id

      commit(CX_CONSENT, cookieConsent)
      commit(CX_PLATFORM, platform)
      // commit(CX_PAGE, page)
      commit(CX_USER, { anonymousId })
    },
    /**
     * Update Navigation state with page name.
     * @param {Object} context Vue context Object
     * @param {Object} routeName used to map to Navigation tracking
     */
    cx_navigation({ commit }, routeName) {
      commit(CX_NAVIGATION, routeName)
    },
    /**
     * Update state `component` value
     *  - When empty `data` object provided, resets `cx_component` state
     * @param {Object} context Vue context Object
     * @param {Object} data matching `cx_component`
     */
    cx_component({ commit }, data) {
      const componentData = Object.keys(data).length === 0 ? cx_component : { ...cx_component, ...data }
      commit(CX_COMPONENT, componentData)
    },
    /**
     * Update state `component` value
     *  - When empty `data` object provided, resets `cx_component` state
     * @param {Object} context Vue context Object
     * @param {Object} data matching `cx_component`
     */
    cx_error({ commit }, data) {
      const componentData = Object.keys(data).length === 0 ? cx_error : { ...cx_error, ...data }
      commit(CX_ERROR, componentData)
    },
    /**
     * Update form state with `newState`.
     * See CHAPI customisation response, `article` value
     * @param {Object} context Vue context Object
     * @param {Object} article matching cx_article schema `{ articleId<String>, articleNameLocal<String>, sectionId<Obj>, sectionNameLocal{Obj} }`
     */
    cx_article({ commit, state }, article) {
      const {
        articleId, articleNameLocal, sectionId, sectionNameLocal
      } = article
      const articleState = {
        articleId: `${articleId}`,
        articleNameLocal,
        sectionId: `${sectionId}`,
        sectionNameLocal
      }

      commit(CX_ARTICLE, { ...state.cx_article, ...articleState })
    },
    /**
     * Update form state with `newState`.
     * See CHAPI customisation response, `article` value
     * @param {Object} context Vue context Object
     * @param {String} articleId matching article id
     */
    cx_articleById({ commit, rootGetters, state }, articleId) {
      const { Title: articleNameLocal, SectionId: sectionId, SectionName: sectionNameLocal } = rootGetters.findArticleById(articleId)
      const articleState = {
        articleId: `${articleId}`,
        articleNameLocal,
        sectionId: `${sectionId}`,
        sectionNameLocal
      }

      commit(CX_ARTICLE, { ...state.cx_article, ...articleState })
    },
    /**
     * Update form state with `newState`.
     * See CHAPI customisation response, `article` value
     * @param {Object} context Vue context Object
     * @param {Object} section matching cx_article schema `{ articleId<String>, articleNameLocal<String>, sectionId<Obj>, sectionNameLocal{Obj} }`
     */
    cx_section({ commit, state }, category) {
      const { id: sectionId, title: sectionNameLocal } = category
      const articleState = {
        articleId: null,
        articleNameLocal: null,
        sectionId: `${sectionId}`,
        sectionNameLocal
      }

      commit(CX_ARTICLE, { ...state.cx_article, ...articleState })
    },
    /**
     * Reset `cx_article` state
     * @param {Object} context Vue context Object
     * @param {Object} section matching cx_article schema `{ articleId<String>, articleNameLocal<String>, sectionId<Obj>, sectionNameLocal{Obj} }`
     */
    resetCxArticle({ commit, state }) {
      const articleState = cx_article

      commit(CX_ARTICLE, { ...state.cx_article, ...articleState })
    },
    /**
     * Update form state with `newState`.
     * See CHAPI customisation response, `order` value
     * @param {Object} context Vue context Object
     * @param {Object} order matching CHAPI Customisation order `null || { friendlyReference<String>, id<String>, restaurant<Obj>, status{Obj} }`
     */
    cx_order({ commit }, order) {
      let orderState = cxOrderDefaults

      if (order?.id) {
        orderState = {
          id: order.id,
          status: order.status?.value || null, // also `order.status.isActive<Bool>`
          timestamp: null,
          total: null // not available atm
        }
      }

      commit(CX_ORDER, orderState)
    }
  },
  getters: {
    cxArticleContext(state) {
      const data = state.cx_article
      const schema = schemaMap.cx_article

      return {
        data, schema
      }
    },
    cxErrorContext(state) {
      const data = state.cx_error
      const schema = schemaMap.cx_error

      return {
        data, schema
      }
    },
    cxComponentContext(state) {
      const data = state.cx_component
      const schema = schemaMap.cx_component

      return {
        data, schema
      }
    },
    /**
     * Get cx_feature from state context
     * @param {Object} state
     * @returns Current `cx_feature` context
     */
    cxFeatureContext(state) {
      const data = state.cx_feature
      const schema = schemaMap.cx_feature
      return {
        data, schema
      }
    },
    /**
     * Get state cx_navigation context
     * @param {Object} state
     * @returns Current ... state
     */
    cxNavigationContext(state) {
      const data = state.cx_navigation
      const schema = schemaMap.cx_navigation

      return {
        data, schema
      }
    },
    /**
     * Get state cx_order context
     * @param {Object} state
     * @returns Current ... state
     */
    cxOrderContext(state) {
      const data = state.cx_order
      const schema = schemaMap.cx_order

      return {
        data, schema
      }
    },
    getUserId({ rootGetters }) {
      const { id } = rootGetters.user
      return {
        id
      }
    }
  }
}
